export const PPT_PROCESSED = "PROCESSED";
export const PPT_UNPROCESSED = "UNPROCESSED";
export const PPT_PENDING = "PENDING";
export const PPT_READYTOPROCESS = "READYTOPROCESS";
export const PPT_PROCESSING = "PROCESSING";
